export default __webpack_public_path__ + "static/media/pwm-negative.c2ab7e47.svg";